@use "styles" as *;
@use "sass:map";

$block: me-link;

.#{$block} {
  display: inline;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &__anchor {
    display: inline-flex;
    gap: space(1);
    text-decoration: none;
    color: inherit;
  }

  &__icon:empty {
    display: none;
  }

  @each $theme, $theme-options in $link-themes {
    &--#{"" + $theme} {
      color: map.get($theme-options, color);
    }
  }

  &--has-icon.#{$block}--primary {
    font-weight: $font-weight-semi-bold;
  }
}
